import { makeAutoObservable, reaction } from "mobx";
import { RootStore } from "../RootStore";
import { MatchResponsePayload } from "../../apis/types";
import { FrontDeskApi } from "../../apis/frontDesk.api";
import { removeDuplicates } from "../../utils/utils";
import { format } from "date-fns";
export class MatchListStore {
  rootStore: RootStore;
  modalData?: {
    visible: boolean;
    title: string;
    children: string;
    btnText?: string;
    btnVariant?: string;
    onClose?: () => void;
    onAccept?: () => void;
    headerIcon?: React.ReactNode;
  };
  date: Date | null = null;
  isLoading: boolean = false;
  matchList: MatchResponsePayload[] = [];
  pageNum: number = 1;
  isStopPagination: boolean = false;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, { rootStore: false });

    reaction(
      () => this.pageNum,
      () => {
        // if (this.pageNum > 1) {
        this.getMatchList();
        // }
      }
    );
    reaction(
      () => this.date,
      () => {
        this.pageNum = 1;
        this.matchList = [];
        this.isStopPagination = false;
        this.getMatchList();
      }
    );
  }
  setDate = (date: Date) => {
    this.date = date;
  };

  getMatchList = async () => {
    this.isLoading = true;
    try {
      const response = await FrontDeskApi.getMatchesList(
        this.pageNum,
        format(this.date ?? new Date(), "MM-dd-yyyy")
      );
      if (response.length === 0) {
        this.isStopPagination = true;
        return;
      }
      this.matchList = removeDuplicates(
        [...this.matchList, ...response],
        (item) => item.id
      );
    } catch (e) {
      this.modalData = {
        visible: true,
        title: "Error",
        children: "Something went wrong while getting match list",
        btnText: "Ok",
        onClose: () => {
          this.modalData = undefined;
        },
      };
    } finally {
      this.isLoading = false;
    }
  };

  increasePageNum = () => {
    if (this.isLoading || this.isStopPagination) return;
    this.pageNum += 1;
  };

  //   deleteOrDropFromBooking = async (id: number, isCancel?: boolean) => {
  //     this.isLoading = true;
  //     try {
  //       isCancel
  //         ? await CourtBookingApi.deleteBooking(id)
  //         : await CourtBookingApi.dropFromBooking(id);
  //       this.getMatchList();
  //     } catch (e) {
  //       this.modalData = {
  //         visible: true,
  //         title: "Error",
  //         children: "Something went wrong while deleting booking",
  //         btnText: "Ok",
  //         onAccept: () => {
  //           this.modalData = undefined;
  //         },
  //       };
  //     } finally {
  //       this.isLoading = false;
  //     }
  //   };

  //   confirmForDeleteDropBooking = async (
  //     id: number,
  //     cancellationDescription?: string,
  //     isCancel?: boolean
  //   ) => {
  //     this.modalData = {
  //       visible: true,
  //       title: "Confirm",
  //       children: `Are you sure you want to ${
  //         isCancel ? "delete" : "drop from"
  //       } this booking?\n${cancellationDescription ?? ""}`,
  //       onClose: () => {
  //         this.modalData = undefined;
  //       },
  //       onAccept: () => {
  //         this.modalData = undefined;
  //         this.deleteOrDropFromBooking(id, isCancel);
  //       },
  //     };
  //   };

  reset = () => {
    this.modalData = undefined;
    this.isLoading = false;
    this.matchList = [];
    this.date = null;
    this.pageNum = 1;
    this.isStopPagination = false;
  };
}
